import { QuickLinkTemplateValidationFields } from '../types/QuickLinkTemplateValidationFields';

const { NameLinkTemplate, AnalyticTags, Redirects, LinkData, SocialMediaTags } = QuickLinkTemplateValidationFields;

export const LinkValueLookupMap = {
  [NameLinkTemplate.Title]: (link) => link?.data?.$marketing_title,
  [NameLinkTemplate.LinkAlias]: (link) => link?.domain_alias?.alias,
  [NameLinkTemplate.OriginalWebURL]: (link) => link?.domain_alias?.$canonical_url,

  [AnalyticTags.Campaign]: (link) => link?.campaign,
  [AnalyticTags.Feature]: (link) => link?.feature,
  [AnalyticTags.Channel]: (link) => link?.channel,
  [AnalyticTags.Tags]: (link) => link?.tags,

  [SocialMediaTags.Title]: (link) => link?.data?.$og_title,
  [SocialMediaTags.Description]: (link) => link?.data?.$og_description,
  [SocialMediaTags.ImageUrl]: (link) => link?.data?.$og_image_url,

  [Redirects]: (platform, link) => link?.data && (link.data[`$${platform}_deepview`] || link.data[`$${platform}_url`]),

  [LinkData]: (fieldName, link) => link?.data && link.data[fieldName],
};
